import { IconContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"
import { LayoutIcon } from "src/libs/useful"

/* Protopia Ecosystem component */ 
const IconPrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: IconContent = ( props.primitive || {} ) as IconContent  
    return <div className={`mx-1 flex-centered data-icon-${primitive.id}`} data-primitive-type={primitive["data-primitive-type"]}> 
        <LayoutIcon
            { ...primitive.data }
            className={ primitive.data?.className + " flex-centered"}
        /> 
    </div>  
}
export default IconPrimitive